import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNotify } from "../context/NotifyContext";

const UploadDocPassPan = ({ open, onClose, onSubmit, initialData }) => {
  const [data, setData] = useState({
    accno: "",
    pan: "",
    other: null,       // cheque / passbook
    panFile: null,
    otherUrl: "",
    panFileUrl: ""
  });

  const {notify} = useNotify()

  /* ---------- PREFILL ---------- */
  useEffect(() => {
    if (initialData) {
      setData(prev => ({
        ...prev,
     accno:initialData?.accno
      }));
    }
  }, [initialData]);

  /* ---------- INPUT ---------- */
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "accno" && /^\d*$/.test(value)) {
      setData(prev => ({ ...prev, accno: value }));
    }

    if (name === "pan") {
      setData(prev => ({
        ...prev,
        pan: value.toUpperCase().trim()
      }));
    }
  };

  /* ---------- FILE ---------- */
  const handleFile = (e) => {
    const { name, files } = e.target;
    if (!files?.length) return;

    setData(prev => ({
      ...prev,
      [name]: files[0]
    }));
  };

  /* ---------- SUBMIT ---------- */
  const submit = () => {
    if (!data.accno) {
      notify("Account number required", 'error');
      return;
    }

    if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(data.pan)) {
      notify("Invalid PAN format" , 'error');
      return;
    }

    if (!data.other) {
      notify("Passbook / Cheque required" ,'error');
      return;
    }

    if (!data.panFile) {
      notify("PAN image required" , 'error');
      return;
    }

    onSubmit(data);
   
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle align="center">Upload KYC Documents</DialogTitle>

      <DialogContent dividers>
        <TextField
          fullWidth
          label="Account Number"
          name="accno"
          value={data.accno}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="PAN Number"
          name="pan"
          value={data.pan}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />

        {[
          { key: "other", label: "Passbook / Cheque" },
          { key: "panFile", label: "PAN Card" }
        ].map((f) => {
          const previewSrc = data[f.key]
            ? URL.createObjectURL(data[f.key])
            : data[`${f.key}Url`];

          return (
            <Box key={f.key} sx={{ mb: 2 }}>
              <label className="text-sm font-medium">{f.label}</label>

              <input
                type="file"
                name={f.key}
                accept="image/*"
                onChange={handleFile}
                className="block w-full text-sm mt-1"
              />

              {previewSrc && (
                <img
                  src={previewSrc}
                  alt="preview"
                  style={{
                    marginTop: 8,
                    width: "100%",
                    height: 130,
                    objectFit: "cover",
                    borderRadius: 8,
                    border: "1px solid #ddd"
                  }}
                />
              )}
            </Box>
          );
        })}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button variant="contained" onClick={submit}>
          Save Documents
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadDocPassPan;
